/** @jsx jsx */
import React from "react"
import { jsx } from "@emotion/core"
import { GLOBAL_SHADOW, colors, measure } from "../styles"

export const PaperMotif = ({ children, ...restProps }) => (
  <div
    css={{
      display: "block",
      // margin: "auto",
      padding: measure.THICK_BORDER,
      backgroundColor: colors.PAPER_WHITE,
      boxShadow: GLOBAL_SHADOW,
    }}
    {...restProps}
  >
    {children}
  </div>
)
